import Page from '../../class/Page';
import TimeZoneSelector from '../../components/timezone-selector';
import phoneField from './partials/phone-field';

window.pageCurrent = class extends Page {
    init() {
        super.init();

        this.initComponent('#country', TimeZoneSelector);

        phoneField('form-register');
    }
};
